"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Errors_1 = require("./Errors");
/**
 * Base class for member function of client
 *
 * @internal
 */
class BaseClass {
    constructor(apiV1, apiV2) {
        this._apiV1 = apiV1;
        this._apiV2 = apiV2;
        this._handleError = Errors_1.handleError;
    }
}
exports.default = BaseClass;
